import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGoalSubgoalProgress } from 'shared/hooks/use-goal-subgoal-progress';
import { useNumberFormat } from 'shared/hooks/use-number-format';
import { metricUnitFormatBase } from 'shared/types/metric-template';

import { InsightsCard } from './insights-card';
import { GoalInsightsCardProps } from './types';

export const GoalInsightsSubGoalCard: React.FC<GoalInsightsCardProps> = ({
  goal,
  startDate,
  endDate,
  hideTimeframeDifference,
  ...rest
}) => {
  const { t } = useTranslation();
  const numberFormat = useNumberFormat();
  const {
    entries,
    completionPercentage,
    completed,
    target,
    timeframeDifference,
  } = useGoalSubgoalProgress(goal, { startDate, endDate });

  const unitFormat = `${metricUnitFormatBase} ${t('general.labels.goal-progress.unit-format.sub-goals.label')}`;

  return (
    <InsightsCard
      goal={goal}
      startDate={startDate}
      endDate={endDate}
      {...rest}
      entries={entries}
      completionPercentage={completionPercentage}
      unitFormat={unitFormat}
      startValue={0}
      target={target}
      timeframeDifference={
        hideTimeframeDifference ? undefined : timeframeDifference
      }
      currentValue={completed}
      numberFormat={numberFormat}
    />
  );
};
